module.exports = __webpack_public_path__ + "img/four.fc75296e.png";